import { MerchEffects } from './merch.effects';

export const effects: any[] = [MerchEffects];

export * from './merch.effects';
